export const BOOK_SALES_DEMO_SOURCES = {
  contactSalesHeader: 'contact_sales_header',
  paywallEnterpriseDemo: 'paywall_enterprise_demo',
  pricingBusinessCard: 'pricing_business_card',
  pricingComparisonBusiness: 'pricing_comparison_business',
  pricingComparisonEnterprise: 'pricing_comparison_enterprise',
  pricingEnterpriseCard: 'pricing_enterprise_card',
  trialPaywallEnterprise: 'trial_paywall_enterprise',
  trialPaywallExperimentBusiness: 'trial_paywall_experiment_business',
  trialPaywallExperimentEnterprise: 'trial_paywall_experiment_enterprise',
  trialPricingEnterpriseBanner: 'trial_pricing_enterprise_banner',
  upgradePlanModalContactUs: 'upgrade_plan_modal_contact_us',
  visualTranslationEditSoon: 'visual_translation_edit_soon',
  visualTranslationPaywall: 'visual_translation_paywall',
} as const;

export type BookSalesDemoSource = (typeof BOOK_SALES_DEMO_SOURCES)[keyof typeof BOOK_SALES_DEMO_SOURCES];
